<template>
  <!-- person -->
  <div class="formGroup isRequired mt15 notranslate">
    <label class="label toCapitalize">{{locale.reservation_person}}</label>

    <select class="input" v-model="person" @change="selectPerson">
      <option
        v-if="!limitedPerson"
        value=""
        disabled>
        {{locale.select_person}}
      </option>

      <option
        v-for="p in personOptions"
        :key="p"
        :value="p">
        {{p}}
      </option>
    </select>
  </div>
  <!-- //person -->
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'ReservationFormPerson',
  props: [
    'lang',
    'ln',
    'locale',
    'info',
    'roomKey',
    'rid',
    'reservePerson',
    'isPublic',
    'userLimitedInfo',
    'min',
    'max'
  ],
  computed: {
    limitedPerson () {
      const person = this.userLimitedInfo && this.userLimitedInfo.person
      return person ? parseInt(person) : null
    },
    personOptions () {
      if (this.limitedPerson) {
        return [this.limitedPerson]
      }

      const min = parseInt(this.min)
      const max = parseInt(this.max)

      const start = Number.isInteger(min) && Number.isInteger(max) && min <= max
        ? min
        : 1

      const end = Number.isInteger(min) && Number.isInteger(max) && min <= max
        ? max
        : 12

      const list = []

      for (let i = start; i <= end; i++) {
        list.push(i)
      }

      return list
    }
  },
  watch: {
    reservePerson (person) {
      this.person = person || ''
    },
    personOptions (options) {
      if (options.length === 1 && this.person !== options[0]) {
        this.person = options[0]
        this.selectPerson()
      }
    }
  },
  mounted () {
    if (this.personOptions.length === 1) {
      this.person = this.personOptions[0]
      this.selectPerson()
    }
  },
  data () {
    const person = (this.userLimitedInfo && this.userLimitedInfo.person) || ''

    return {
      person,
      personInput: ''
    }
  },
  methods: {
    updatePerson () {
      const person = regExp.numberOnly(this.personInput) || ''
      this.personInput = person

      if (this.person === 'input') {
        this.selectPerson()
      }
    },
    selectPerson () {
      this.$emit('setPerson', this.person)
    }
  }
}
</script>